import clsx from "clsx";

const SimpleBadge: React.FC<{ label: React.ReactNode; colorClassName?: string }> = ({ label, colorClassName }) => {
  return (
    <span
      className={clsx(
        "inline-flex items-center rounded-md  px-2 py-1 text-[10px] 2xl:text-xs font-medium  ring-1 ring-inset",
        colorClassName ? colorClassName : "text-gray-600 bg-gray-50 ring-gray-500/10",
      )}
    >
      {label}
    </span>
  );
};

export default SimpleBadge;
